import { render, staticRenderFns } from "./InstanceManagement.vue?vue&type=template&id=4a4c8564&"
import script from "./InstanceManagement.vue?vue&type=script&lang=js&"
export * from "./InstanceManagement.vue?vue&type=script&lang=js&"
import style0 from "./InstanceManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports